function formatPrice(priceToFormat) {
  return ((Math.ceil(priceToFormat / 5) * 5) / 100).toFixed(2)
}

function priceToString(price) {
  return `${formatPrice(price)} €`
}

export { priceToString }
